import { Game, PuzzleCell, PuzzleWord, PuzzleClue } from "./game";

export class AndrewsMcMeel {
  static parse(data: any) {
    // Parse the layout to determine cell types and numbers
    const layout: string[] = [];
    for (let i = 1; i <= 15; i++) {
      layout.push(data.Layout[`Line${i}`]);
    }

    // Parse the solution
    const solution: string[] = [];
    for (let i = 1; i <= 15; i++) {
      solution.push(data.Solution[`Line${i}`]);
    }

    // Parse clues
    const acrossClues = data.AcrossClue.split('\n').map((clue: string) => {
      const [num, text] = clue.split('|');
      return {
        number: parseInt(num),
        text: text.trim()
      };
    });

    const downClues = data.DownClue.split('\n').map((clue: string) => {
      const [num, text] = clue.split('|');
      return {
        number: parseInt(num),
        text: text.trim()
      };
    });

    // Initialize puzzle
    Game.puzzle.width = parseInt(data.Width);
    Game.puzzle.height = parseInt(data.Height);
    Game.puzzle.title = data.Title;
    Game.puzzle.creator = data.Author;
    Game.puzzle.valid = true;

    // Parse date
    const dateStr = data.Date;
    Game.puzzle.year = parseInt(dateStr.substring(0, 4));
    Game.puzzle.month = parseInt(dateStr.substring(4, 6));
    Game.puzzle.day = parseInt(dateStr.substring(6, 8));
    Game.puzzle.date_string = dateStr;

    // Create cells array
    const cells: PuzzleCell[] = [];
    const words: { [key: string]: PuzzleWord } = {};
    let wordId = 1;

    // Process layout and solution to create cells
    for (let y = 0; y < Game.puzzle.height; y++) {
      const layoutLine = layout[y];
      const solutionLine = solution[y];
      let x = 0;
      let i = 0;

      while (i < layoutLine.length) {
        if (layoutLine[i] === '-') {
          // Block cell
          cells.push({
            x: x + 1,
            y: y + 1,
            type: "block",
            solution: "",
            guess: "",
            number: null,
            show_error: false
          });
          i += 2; // Skip "-1"
        } else {
          // Regular cell
          const num = parseInt(layoutLine.substring(i, i + 2));
          cells.push({
            x: x + 1,
            y: y + 1,
            type: "",
            solution: solutionLine[x],
            guess: "",
            number: num > 0 ? num : null,
            show_error: false
          });
          i += 2;
        }
        x++;
      }
    }

    // Find words
    const acrossWords: PuzzleWord[] = [];
    const downWords: PuzzleWord[] = [];
    const downWordNumbers: { [key: number]: PuzzleWord } = {};

    // Find across words
    for (let y = 0; y < Game.puzzle.height; y++) {
      let wordStart = -1;
      let wordLength = 0;

      for (let x = 0; x < Game.puzzle.width; x++) {
        const idx = y * Game.puzzle.width + x;
        const cell = cells[idx];

        if (cell.type !== "block") {
          if (wordStart === -1) {
            wordStart = x;
          }
          wordLength++;
        } else {
          if (wordLength > 1) {
            const word: PuzzleWord = {
              length: wordLength,
              x: wordStart + 1,
              y: y + 1,
              id: wordId,
              idx: acrossWords.length
            };
            acrossWords.push(word);
            wordId++;
          }
          wordStart = -1;
          wordLength = 0;
        }
      }

      // Handle word at end of row
      if (wordLength > 1) {
        const word: PuzzleWord = {
          length: wordLength,
          x: wordStart + 1,
          y: y + 1,
          id: wordId,
          idx: acrossWords.length
        };
        acrossWords.push(word);
        wordId++;
      }
    }

    // Find down words
    for (let x = 0; x < Game.puzzle.width; x++) {
      let wordStart = -1;
      let wordLength = 0;
      let wordNumber = 0;

      for (let y = 0; y < Game.puzzle.height; y++) {
        const idx = y * Game.puzzle.width + x;
        const cell = cells[idx];

        if (cell.type !== "block") {
          if (wordStart === -1) {
            wordStart = y;
            wordNumber = cell.number || 0;
          }
          wordLength++;
        } else {
          if (wordLength > 1) {
            const word: PuzzleWord = {
              length: wordLength,
              x: x + 1,
              y: wordStart + 1,
              id: wordId,
              idx: downWords.length
            };
            downWordNumbers[wordNumber] = word;
            wordId++;
          }
          wordStart = -1;
          wordLength = 0;
        }
      }

      // Handle word at end of column
      if (wordLength > 1) {
        const word: PuzzleWord = {
          length: wordLength,
          x: x + 1,
          y: wordStart + 1,
          id: wordId,
          idx: downWords.length
        };
        downWordNumbers[wordNumber] = word;
        wordId++;
      }
    }

    // Sort down words by their numbers
    const sortedDownNumbers = Object.keys(downWordNumbers).map(Number).sort((a, b) => a - b);
    sortedDownNumbers.forEach((num, idx) => {
      const word = downWordNumbers[num];
      word.idx = idx;
      downWords.push(word);
    });

    // Create clue arrays
    const acrossCluesArray: PuzzleClue[] = acrossWords.map((word, idx) => ({
      word_id: word.id,
      text: acrossClues[idx].text,
      number: acrossClues[idx].number
    }));

    const downCluesArray: PuzzleClue[] = downWords.map((word, idx) => ({
      word_id: word.id,
      text: downClues[idx].text,
      number: downClues[idx].number
    }));

    // Set the puzzle data
    Game.puzzle.cells = cells;
    Game.puzzle.across_words = acrossWords;
    Game.puzzle.down_words = downWords;
    Game.puzzle.across_clues = acrossCluesArray;
    Game.puzzle.down_clues = downCluesArray;

    // Initialize input cells
    Game.input.cells = cells.map(cell => ({
      ...cell,
      guess: ""
    }));
  }
}
